var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useBuildStyleWithTheme } from '@cvent/carina-theme-provider';
var buildStyle = function (_a, _b) {
    var font = _a.font;
    var readingDirection = _b.readingDirection;
    return {
        verticalWrapper: {
            base: {
                margin: '-8px 0 0 0',
                width: '100%'
            }
        },
        horizontalWrapper: {
            base: {
                display: 'flex',
                color: font.color.base,
                justifyContent: 'center'
            }
        },
        readingDirection: readingDirection
    };
};
var useStyle = function (_a) {
    var isRtl = _a.isRtl, presentation = _a.presentation;
    var builtStyle = useBuildStyleWithTheme(buildStyle, { isRtl: isRtl });
    if (!builtStyle) {
        return {
            wrapper: {}
        };
    }
    var verticalWrapper = builtStyle.verticalWrapper, horizontalWrapper = builtStyle.horizontalWrapper, readingDirection = builtStyle.readingDirection;
    return {
        wrapper: __assign(__assign(__assign({}, (presentation === 'vertical' && verticalWrapper.base)), (presentation === 'horizontal' && horizontalWrapper.base)), readingDirection)
    };
};
export default useStyle;
